function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="9" height="9" viewBox="-7 -1 10 10" {...props}><path d="M2.301 1.523L1.477.7-2 4.176-5.477.699l-.824.824L-2.824 5l-3.477 3.477.824.824L-2 5.824l3.477 3.477.824-.824L-1.176 5l3.477-3.477z" /></svg>;
});